import { atom } from "jotai";

export const isInfiniteScrollArticleAtom = atom<boolean>(false);
